// const languageCodeToName = {
//     en: 'English',
//     es: 'Spanish',
//     fr: 'French',
//     de: 'German',
//     zh: 'Chinese',
//     ja: 'Japanese',
//     ar: 'Arabic',
//     id: 'Indonesian',
//     ko: 'Korean',
//     my: 'Burmese',
//     pt: 'Portuguese',
//     ru: 'Russian',
//     th: 'Thai',
//     vi: 'Vietnamese',
//     // Add more language codes and names as needed
//   };
  
//   export const getLanguageName = (code) => {
//     return languageCodeToName[code] || code; // Return the name if available, otherwise fallback to code
//   };

export const getLanguageName = (code) => {
    try {
      const displayNames = new Intl.DisplayNames(['en'], { type: 'language' });
      return displayNames.of(code) || code; // Return the name if available, otherwise fallback to code
    } catch (error) {
      console.error('Intl.DisplayNames is not supported in this environment', error);
      return code; // Fallback to code if Intl.DisplayNames is not supported
    }
  };

  // Function to get country name from code using Intl.DisplayNames
export const getCountryName = (code) => {
    try {
      const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
      return displayNames.of(code) || 'Unknown Country';
    } catch (error) {
      console.error('Intl.DisplayNames is not supported in this environment', error);
      return 'Unknown Country';
    }
  };